
// import { CustomImage } from '@/components/molecules'
import styled from 'styled-components';
import devices from '@/utilities/devices';

// #region STYLE
const HalfSplitContainer = styled.section<{ backgroundColor: 'red' | 'blue' | 'prune' | 'beige' | 'black' | 'grey'; backgroundImage: string }>`
	background-color: ${({ backgroundColor, theme }) => theme.color[backgroundColor]};
	color: ${({ backgroundColor, theme }) => {
		switch (backgroundColor) {
			case 'red':
				return theme.color.white;
			case 'blue':
				return theme.color.black;
			case 'prune':
				return theme.color.white;
			case 'beige':
				return theme.color.prune;
			case 'black':
				return theme.color.white;
			case 'grey':
				return theme.color.black;
			default: theme.color.white;
		}
	}};
	display: flex;
	justify-content: center;
	min-height: calc(100vh - 70px);

	> div:first-child {
		align-items: flex-start;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 7rem 0 10rem;
		width: 65%;
	}

	> div:last-child {
		position: relative;
		width: 35%;
		z-index: 0;
		background-image: url(${({ backgroundImage }) => `${backgroundImage}`});
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		@media (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi) {
			background-image: url(${({ backgroundImage }) => `${backgroundImage}`});
		}
	}

	@media screen and (${devices.mobile}) {
		flex-direction: column;
		min-height: auto;
		padding: 2rem 1rem;
		> div:first-child {
			align-items: center;
			padding: 0;
			width: 100%;
		}
		> div:last-child {
			display: none;
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		min-height: auto;
		padding: 2rem 1rem;
		> div:first-child {
			align-items: center;
			padding: 0;
			width: 100%;
		}
		> div:last-child {
			display: none;
		}
	}
	@media screen and (${devices.min2k}) and (${devices.max2k}) {
		> div:first-child {
			width: 60rem;
		}
		> div:last-child {
			width: 60rem;
		}
	}
	@media screen and (${devices.min4k}) and (${devices.max4k}) {
		> div:first-child {
			width: 80rem;
		}
		> div:last-child {
			width: 80rem;
		}
	}
`;
// #endregion

const HalfSplitWithImage = ({ children, backgroundUrl }: {
	alt: string;
	backgroundUrl: string;
	children: any;
}) => {
	return (
		<HalfSplitContainer backgroundColor='prune' backgroundImage={backgroundUrl}>
			<div>
				{children}
			</div>
			<div>
				{/* <CustomImage
					alt={alt}
					layout='fill'
					objectFit='cover'
					priority
					quality={100}
					src={backgroundUrl}
				/> */}
			</div>
		</HalfSplitContainer>
	);
};

export default HalfSplitWithImage;
